var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Worker Config")]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "8", md: "8" } },
                    [
                      _c("r-worker-key", {
                        attrs: { model: _vm.model.worker, "hide-details": "" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "worker", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Capacity (units):",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model.capacity,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "capacity", _vm._n($$v))
                          },
                          expression: "model.capacity",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "SleepTime:", "hide-details": "" },
                        model: {
                          value: _vm.model.sleepTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "sleepTime", _vm._n($$v))
                          },
                          expression: "model.sleepTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "RushTime:", "hide-details": "" },
                        model: {
                          value: _vm.model.rushTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "rushTime", _vm._n($$v))
                          },
                          expression: "model.rushTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "LifeTime:", "hide-details": "" },
                        model: {
                          value: _vm.model.lifeTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "lifeTime", _vm._n($$v))
                          },
                          expression: "model.lifeTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Public", "hide-details": "" },
                        model: {
                          value: _vm.model.public,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "public", $$v)
                          },
                          expression: "model.public",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Shared", "hide-details": "" },
                        model: {
                          value: _vm.model.shared,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "shared", $$v)
                          },
                          expression: "model.shared",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }